import { For, Show } from "solid-js";

export default function ActionItemsPanel(props: {
  items: { id: string; text: string; done: boolean }[];
  onToggle: (id: string) => void;
}) {
  return (
    <div class="card">
      <h2 class="text-lg font-semibold mb-2">Action Items</h2>
      <Show when={props.items.length} fallback={<p>No items yet.</p>}>
        <ul class="space-y-2">
          <For each={props.items}>
            {(a) => (
              <li
                class="flex items-center gap-2 text-sm cursor-pointer"
                onClick={() => props.onToggle(a.id)}
              >
                <input type="checkbox" checked={a.done} readonly />
                <span class={a.done ? "line-through opacity-50" : ""}>
                  {a.text}
                </span>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </div>
  );
}
